import f from './functions.js'
import FaceId from './utils/faceid.js'
import Autoupdater from './utils/autoupdater.js'
import Purchases from './utils/purchases.js'
class Cordovakit {
	constructor(core){

		this.core = core
		this.store = this.core.store
		this.vm = this.core.vm
		this.faceid = new FaceId(this)
		this.autoupdater = new Autoupdater(core)
		this.purchases = new Purchases(core)

	}

	prepare(){

		document.documentElement.style.setProperty('--keyboardheight', `0px`);

		if (!window.cordova && f.isios()){
			document.documentElement.classList.add('noncordovaios')
		}

		if (!window.cordova) return

		if (navigator.splashscreen) navigator.splashscreen.hide();

		window.screen.orientation.lock('portrait')

		document.documentElement.style.setProperty('--app-margin-top-default', `20px`);

		if(f.isios() && window.cordova){
			document.documentElement.style.setProperty('--app-margin-bottom-default', `30px`);
		}
		else{
			document.documentElement.style.setProperty('--app-margin-bottom-default', `0px`);
		}
			
		
		this.keyboard()
		this.links()
		this.openwith()
		this.barsEnv()

		setTimeout(() => {
			this.autoupdater.hasupdates().catch(e => {
				console.error(e)
			})
		}, 10000)

	}
	galleryBackground(enable){

		if(!window.cordova) return

		if(enable){
			window.StatusBar.hide()
			window.NavigationBar.hide()
		}
		else{
			window.StatusBar.show()
			window.NavigationBar.show()

			this.barsEnv()
		}
		
	}

	playingStoryBackground(enable){

		if(!window.cordova) return

		if(enable){
			if (window.NavigationBar){
				window.NavigationBar.backgroundColorByHexString("#000", false);
			}
		}
		else{
			this.barsEnv()
		}
		
	}

	unsleep(t) {

		if (window.plugins && window.plugins.insomnia) {

			if (t) window.plugins.insomnia.keepAwake()
			else window.plugins.insomnia.allowSleepAgain()
		}

	}

	barsEnv(){
		var colors = {
			white: "#FFF",
			black: "#1e2235"
		}

		var theme = this.store.state.theme || 'white'

		if (window.StatusBar) {
			window.StatusBar.overlaysWebView(true);
			window.StatusBar.backgroundColorByHexString('#00000000');

			theme == 'white' ? window.StatusBar.styleDefault() : window.StatusBar.styleLightContent()
		}

		if (window.NavigationBar){

			var c = theme

			if(!colors[c]) c = 'white'

			window.NavigationBar.backgroundColorByHexString(colors[c], c == 'white');
		}
	}

	keyboard(){
		window.addEventListener('keyboardWillShow', (event) => {

			var h = f.isios() ? event.keyboardHeight : Math.max(event.keyboardHeight, Math.min(260, window.innerHeight / 2))

			document.documentElement.style.setProperty('--keyboardheight', `${h}px`);

			if (document.activeElement){
				document.activeElement.closest('.customscroll').scrollTop = document.activeElement.offsetTop - 100
			}
		});

		window.addEventListener('keyboardWillHide', () => {
			document.documentElement.style.setProperty('--keyboardheight', `${0}px`);
		});

		if (window.Keyboard && window.Keyboard.disableScroll) {
			window.Keyboard.disableScroll(false)
		}
		
	}

	links() {
		if (universalLinks != 'undefined'){
            universalLinks.subscribe('route-message', (eventData) => {

				var route = (eventData.url || '').replace('https://snippity.app', '')

				console.log('eventData.url', eventData.url, route)

				if (route){
					this.core.vm.$router.push(route).catch(e => {})
				}
				
            });
        }
	}

	openwith(){

		if(!cordova.openwith) return

		var mime = {

			'image/jpeg' : 'images',
			'image/jpg' : 'images',
			'image/png' : 'images',
			'image/webp' : 'images'

		}

		var utitomime = {
			'public.image' : 'image/jpeg'
		}

		cordova.openwith.init();
		cordova.openwith.addHandler(function(intent){
			var sharing = {}

			if(intent.action == 'VIEW') return

			var promises = _.map(
				_.filter(intent.items || [], function(i){return i}),
				(item) => {

				return new Promise((resolve, reject) => {


					if(utitomime[item.type]) item.type = utitomime[item.type]

					if(item.base64 && f.isios()) item.data = 'data:' + item.type + ';base64,' + item.base64

					if(!item.type || item.data){
						resolve()
					}
					else{
						cordova.openwith.load(item, function(data) {

							item.data = 'data:' + item.type + ';base64,' + data

							resolve()

						});
					}


				}).then(r => {

					if (item.text){
						if(!sharing.messages) sharing.messages = []

						sharing.messages.push(item.text)
					}

					if(item.type && item.data){

						var mt = mime[item.type] || 'files'

						if(!sharing[mt]){
							sharing[mt] = []
						}

						sharing[mt].push(item.data)
					}

					return Promise.resolve()
				})
			})


			Promise.all(promises).then(r => {

				if (intent.exit) { cordova.openwith.exit(); }

				if(_.isEmpty(sharing)){
					
				}
				else{

					if(sharing.images || sharing.files){

						var up = [].concat(sharing.images, sharing.files)


						return Promise.all(_.map(up, (f) => {
							return f.Base64.toFileFetch(f)
						})).then(files => {
							this.store.commit('uploading', files)

							this.core.vuieapi.fileManager()
						})
						
					}

				}
			})
		});

	}

	vibration(total){

		if(f.isios()){

			if(typeof TapticEngine != 'undefined')
				TapticEngine.impact({
					style: "medium"
				});

		}
		else{
			if (navigator.vibrate){
				navigator.vibrate(50)
			}
		}

	   
	}


	_faceid() {

		if(!window.plugins.touchid) return Promise.reject('notavailable')

		return new Promise((resolve, reject) => {

			window.plugins.touchid.isAvailable(
				function(type) {

					if(localStorage['usefaceid']){

						window.plugins.touchid.didFingerprintDatabaseChange(

							function(changed) {
								
								if (changed) {
									reject('unauthorized')
								} else {

									window.plugins.touchid.verifyFingerprintWithCustomPasswordFallback(
										type == 'face' ? "Face ID" : 'Touch ID', // this will be shown in the native scanner popup
										function(msg) {
											resolve()
										}, // success handler: fingerprint accepted
										function(msg) {
				
											reject('unauthorized')
				
										} // error handler with errorcode and localised reason
									);

								}
							}
						);

					}
					else{
						return reject('usefaceid')
					}

				}, // type returned to success callback: 'face' on iPhone X, 'touch' on other devices
				function(msg) {

					return reject('notavailable')

				} 
			);

		})

		
	}

}

export default Cordovakit